import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Pictogram } from 'foundations-components/transitional/components/Pictogram';
import { H3 } from 'foundations-components/transitional/components/H3';
import { Section } from 'foundations-components/transitional/components/Section';
import { View } from 'foundations-components/components/View';
import FinishedContainer from '../FinishedContainer.migrated';
import TrackViewAwardLink from '../TrackCard/TrackViewAwardLink';
import { useUserInfo } from '../../features/accounts';
import { isExpired } from '../../features/exams/examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackCertificationCompletionScreen = ({
  track,
  trackAward
}) => {
  const {
    userInfo
  } = useUserInfo();
  const expired = isExpired(trackAward.expiresAt);
  return /*#__PURE__*/_jsx(FinishedContainer, {
    body: /*#__PURE__*/_jsxs(View, {
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.tracks.interstitials.certificationCompleteHeading",
          options: {
            firstName: userInfo && userInfo.user.firstName
          }
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "learningCenter.tracks.interstitials.certificationCompleteSubheading",
          options: {
            courseName: track.name,
            completedDate: /*#__PURE__*/_jsx(FormattedDateTime, {
              format: "ll",
              value: trackAward.awardedAt
            })
          }
        })
      }), /*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(TrackViewAwardLink, {
          award: trackAward,
          certification: true,
          confettiAwardedAtMs: trackAward.awardedAt,
          expired: expired,
          trackId: track.id
        })
      })]
    }),
    illustration: /*#__PURE__*/_jsx(Pictogram, {
      name: "CelebrationSuccess"
    })
  });
};
export default TrackCertificationCompletionScreen;